import { render, staticRenderFns } from "./OrderPaymentConfirmed.vue?vue&type=template&id=5af7b9b8&scoped=true&"
import script from "./OrderPaymentConfirmed.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7b9b8",
  null
  
)

export default component.exports